var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { PainIntensityEnum } from '../enums/pain-intensity.enum.js';
export class AnamnesisLiteDto {
    id;
    createdAt;
    updatedAt;
    updatedById;
    updatedBy;
    userId;
    icd10Id;
    symptomDescription;
    painSensations;
    painScale;
    painDuration;
    secondarySymptoms;
    painTrigger;
    painOccurrences;
    painIntensity;
    painRadiation;
    additionalFactors;
    successTarget;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], AnamnesisLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], AnamnesisLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisLiteDto.prototype, "updatedById", void 0);
__decorate([
    IsUUID(),
    Expose(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], AnamnesisLiteDto.prototype, "updatedBy", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisLiteDto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "icd10Id", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "symptomDescription", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painSensations", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painScale", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painDuration", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "secondarySymptoms", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painTrigger", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painOccurrences", void 0);
__decorate([
    IsEnum(PainIntensityEnum),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painIntensity", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "painRadiation", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "additionalFactors", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisLiteDto.prototype, "successTarget", void 0);
//# sourceMappingURL=anamnesis.lite.dto.js.map